export default __webpack_public_path__ + "fe9c2af4170681ac79c457d5c85db641.png";